import { useQuery } from '@tanstack/react-query';

import type { BrandWithThemes } from '../types';

import { buildInsightReqBody } from '@/entities/insight/utils';
import { socialApiClient } from '@/shared/api-client/social-api-client';
import type { PublicFilter } from '../../shared/public-filter/use-public-filter';

async function fetchBrandsWithThemes(
  {
    queryId,
    startDate,
    endDate,
    publicFilter,
  }: {
    queryId: string;
    startDate: string;
    endDate: string;
    publicFilter: PublicFilter;
  },
  signal?: AbortSignal,
): Promise<BrandWithThemes[]> {
  const requestBody = buildInsightReqBody(startDate, endDate, 100, publicFilter);

  const response = await socialApiClient
    .post(`queries/${queryId}/insight/conversation/related/brands`, {
      json: requestBody,
      signal,
    })
    .json<BrandWithThemes[]>();

  return response;
}

export function useBrandsWithThemes(params: Parameters<typeof fetchBrandsWithThemes>[0]) {
  const query = useQuery({
    queryKey: [
      'brands-with-themes',
      params.queryId,
      params.startDate,
      params.endDate,
      JSON.stringify(params.publicFilter),
    ],
    queryFn: ({ signal }) => fetchBrandsWithThemes(params, signal),
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
  });

  return query;
}
